import { useNavigate } from 'react-router-dom';
import PageLayout from '../../components/PageLayout/PageLayout';
import {
  NotFoundWrapper,
  NotFoundCode,
  NotFoundTitle,
  NotFoundBody,
  HomeButton,
} from './NotFoundPage.styled';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout page="notfound">
      <NotFoundWrapper>
        <NotFoundCode>404</NotFoundCode>
        <NotFoundTitle>Page Not Found</NotFoundTitle>
        <NotFoundBody>
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </NotFoundBody>
        <HomeButton onClick={() => navigate('/input')}>Back to Home</HomeButton>
      </NotFoundWrapper>
    </PageLayout>
  );
};

export default NotFoundPage;
